import { firebase } from '../rebase.js';
import * as fileDownload from 'js-file-download';

export default function DownloadFromRef(ref, fn, callback) {
  firebase.storage().ref(ref).getDownloadURL().then(function(url) {
    var xhr = new XMLHttpRequest(); 
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function(event) {
      if (xhr.status === 200) {
        fileDownload(xhr.response, fn);
      }
      if (callback) callback();
    };  
    xhr.send();
  }.bind(this)).catch(function(error) {
    console.log(error);
    if (callback) callback();
  })
}


// WEBPACK FOOTER //
// ./src/common/DownloadFromRef.js